<template>
  <div class="markdown" :class="isViewClass">
    <div class="markdown__wrapper">
      <!-- marked text -->
      <MarkdownText
        v-if="!showMarkdownEditor && toParse"
        v-on="$listeners"
        :class="[editorClass]"
        :text="toParse"
        @click.native="isEditPage && toggleEditor($event)"
      />
      <!-- edition -->
      <template v-if="allowEdition">
        <transition :name="transitionName">
          <MarkdownEditor
            v-if="showMarkdownEditor"
            :to-parse="toEdit"
            :placeholder="placeholder"
            :compact="breakpoint || compact"
            @edited="updateMarkdown"
            @canceled="saveMarkdownDraft"
          />
        </transition>
      </template>
    </div>
    <!-- in case of added actions -->
    <slot name="append-markdown" :isEditorOpen="showMarkdownEditor" :toggleEditor="toggleEditor" />
  </div>
</template>

<script>
// Utilities
import TemplatePageControl from 'Modules/Templates/mixins/page-control'
// Components
import MarkdownText from './components/MarkdownText'
import MarkdownEditor from './components/MarkdownEditor'

export default {
  name: 'Markdown',

  components: {
    MarkdownText,
    MarkdownEditor,
  },

  props: {
    text: {
      type: String,
      required: true,
    },

    allowEdition: {
      type: Boolean,
      default: false,
    },

    compact: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: '',
    },
  },

  mixins: [TemplatePageControl],

  data() {
    return {
      markdownDraft: '',
      toParse: this.text,
      showMarkdownEditor: false,
      breakpoint: window.innerWidth < 680,
    }
  },

  methods: {
    toggleEditor(event) {
      if (event && event.target.localName === 'a') return
      this.showMarkdownEditor = !this.showMarkdownEditor
    },

    saveMarkdownDraft(value) {
      this.markdownDraft = value
      this.toggleEditor()
    },

    updateMarkdown(value) {
      this.toParse = value
      this.markdownDraft = ''
      this.$emit('updated', this.toParse)
      this.toggleEditor()
    },
  },

  computed: {
    toEdit() {
      return this.markdownDraft ? this.markdownDraft : this.toParse
    },

    editorClass() {
      return this.isEditPage && 'editor'
    },

    isViewClass() {
      return !this.isTemplatePage && 'is-view'
    },

    transitionName() {
      return !this.isTemplatePage ? 'scale-in' : ''
    },
  },
}
</script>

<style scoped>
.markdown__expand {
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  width: 100%;
  color: var(--c-primary);
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 -30px 15px 4px rgb(244 244 250 / 88%);
}
</style>
